interface AppConfig {
  baseUrl: string;
  clientId: string;
}

let config: AppConfig | null = null;

async function loadConfig(): Promise<AppConfig> {
  if (config) {
    return config;
  }

  try {
    // Assumes config.json is at the root of the add-in's web server.
    const response = await fetch("config.json");
    if (!response.ok) {
      throw new Error(`Failed to fetch config.json: ${response.statusText}`);
    }
    config = await response.json();
    return config!;
  } catch (error) {
    console.error("Failed to load configuration:", error);
    throw new Error("Could not load application configuration.");
  }
}

export const getBaseUrl = async (): Promise<string> => (await loadConfig()).baseUrl;
export const getAppClientIdFromConfig = async (): Promise<string> => (await loadConfig()).clientId;
